var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 16","fill":"none","width":_vm.width,"height":_vm.height}},[_c('g',[_c('path',{attrs:{"d":"M8.05127 14.7104L1.49999 7.87254","stroke":_vm.color,"stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.25 1.55688L1.69872 8.39479","stroke":_vm.color,"stroke-width":"1.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }